"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OverviewProvider = exports.OverviewContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useToggle = require("../hooks/useToggle");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const OverviewContext = exports.OverviewContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
OverviewContext.displayName = 'OverviewContext';
const OverviewProvider = (param)=>{
    let { children } = param;
    const [isOverviewOpen, toggleOverviewOpen] = (0, _useToggle.useToggle)(false);
    const value = (0, _react.useMemo)(()=>({
            isOverviewOpen,
            toggleOverviewOpen
        }), [
        isOverviewOpen,
        toggleOverviewOpen
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(OverviewContext.Provider, {
        value: value,
        children: children
    });
};
exports.OverviewProvider = OverviewProvider;
